import { useEffect, useRef } from "react"

interface UseScrollToBottomOptions {
  trigger: number | string | boolean
  enabled?: boolean
}

interface UseScrollToBottomReturn {
  ref: React.RefObject<HTMLElement>
}

export const useScrollToBottom = ({ trigger, enabled = true }: UseScrollToBottomOptions): UseScrollToBottomReturn => {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (enabled && ref.current) {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: "smooth",
      })
    }
  }, [trigger, enabled])

  return { ref }
}
